import { LinearProgress, Grid } from "@mui/material";
import React from "react";

interface SplashScreenProps {
    children?: React.ReactNode;
}

export default function SplashScreen({ children }: SplashScreenProps) {

    return (
        <Grid container direction="column" justifyContent="space-between" alignItems="center" height="100vh" width="100vw">
            <Grid item><LinearProgress /></Grid>
            <Grid item>
            <img
                    src={"/logo-full192.png"}
                    style={{width: '100%', textAlign: 'center', margin: 'auto', maxWidth: 600}}
                    alt={"ElecTrek"}
                    className={"shadow"}
                />
            </Grid>
            {children ? <Grid item>{children}</Grid> : null}
            <Grid item><LinearProgress /></Grid>
        </Grid>
    )
}
